import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import FishDisease from '../../../../components/Operation/FishDisease';
import { useBiology } from "../../../../contexts/PlanOperationContext/Biology";
import { selectSetting } from "../../../../util/store/selectors";
import { KEY_TAB } from "../../../../util/varibles/constants";
import { checkZero } from "../../../../util/varibles/global";
import { ISite } from "../../../../util/varibles/interface";
import { PlanSetting } from "../../../../util/varibles/userSetting";
import { selectPlan } from "../../constants";
import Cards from "../_components/Cards";
import Location from "../_components/Location";
import stylesContainer from "../style.module.scss";
import Card from "./Card";
import HeaderTab from "./HeaderTab";

const initState = {
    searchValue: '',
}

export default function LocationsTab() {
    const loading = useSelector(selectPlan.loadingSites);
    const [sites] = useBiology(state => state.productionSites);
    const [{ searchValue }, setForm] = useState(initState);
    const { [PlanSetting.LOCATION_PROD_AREA]: prodAreaFilter } = useSelector(selectSetting([PlanSetting.LOCATION_PROD_AREA]))
    const listOfProdAreaFilter = useMemo(() => new Set(prodAreaFilter), [prodAreaFilter]);

    const source = useMemo(() => {
        return sites.filter(site => {
            const isProdArea = listOfProdAreaFilter.size === 0 || listOfProdAreaFilter.has(site.prod_area);
            const isSearch = site.name.toLowerCase().indexOf((searchValue || '').toLowerCase()) !== -1;
            return isSearch && isProdArea;
        })
    }, [sites, listOfProdAreaFilter, searchValue])

    return <div id={KEY_TAB.LOCATIONS} className={stylesContainer['wrapper-tab']}>
        <HeaderTab
            sites={sites}
            siteFilter={source.length}
            onSearch={value => setForm(prev => ({ ...prev, searchValue: value }))}
        />
        <div className={stylesContainer['tab-body']}>
            <Cards<ISite>
                data={source}
                loading={loading}
                child={{
                    height: 60,
                    View: ({ data }) => {
                        const { prod_area, diseases, units } = data;
                        return <Card data={data} key={data.id}>
                            <div className={stylesContainer.line}>
                                <div className="flex items-center gap-[2px] leading-[18px] flex-wrap font-[600] !text-[14px]">
                                    {prod_area ? <>
                                        <span>{`P${checkZero(prod_area)}`}</span>
                                        <span>|</span>
                                    </> : null}
                                    <Location source={[data.name]} style={{ fontSize: '14px', fontWeight: 600, lineHeight: '18px' }} />
                                    <span>({(units || []).length})</span>
                                </div>
                                <div className={stylesContainer.infoLine} data-right={true}>
                                    {units[0] && <FishDisease diseases={diseases} units={[units[0]]} short={true} />}
                                </div>
                            </div>
                        </Card>
                    }
                }}
            />
        </div>
    </div>
}

